<template>
  <div>
    <a-popover trigger="hover" v-model="visible" :getPopupContainer="triggerNode => triggerNode.parentNode">
      <template slot="content">
        <a-row type="flex" class="navbar-more-popover">
          <a-col flex="2">
            <a-menu class="more-popover-menu" @click="menuClick">
              <a-menu-item class="more-popover-menu-item" key="docs"><a-icon type="read" />{{$t('navbar.button.docs')}}</a-menu-item>
              <a-menu-item class="more-popover-menu-item" key="issues"><a-icon type="github" />{{$t('scope.submit.issue')}}</a-menu-item>
              <a-menu-item class="more-popover-menu-item" key="cloudaccount_guide" v-if="isAdminMode || isDomainMode"><a-icon type="control" />{{$t('scope.cloudaccount.guide')}}</a-menu-item>
              <a-menu-item class="more-popover-menu-item" key="features" v-if="isAdminMode"><a-icon type="profile" />{{$t('navbar.button.feature_select')}}</a-menu-item>
              <a-menu-item class="more-popover-menu-item" key="about" v-if="isAdminMode"><a-icon type="question-circle" />{{$t('navbar.button.about')}}</a-menu-item>
            </a-menu>
          </a-col>
          <a-col flex="3">
            <a-card class="more-popover-card">
              <img src="./wechat_qrcode.png"  alt="WeChat QRCode" width="160" />
              <a-card-meta :title="$t('scope.join.community')" :style="{ textAlign: 'center', fontWeight: 400, color: 'forestgreen'}">
                <template slot="description" v-if="companyInfo.hotline">
                  <a-tooltip :title="$t('navbar.text.hotline')">
                    <a-button type="dashed" shape="round" icon="phone">{{ companyInfo.hotline }}</a-button>
                  </a-tooltip>
                </template>
              </a-card-meta>
            </a-card>
          </a-col>
        </a-row>
      </template>
      <div class="trigger d-flex align-items-center justify-content-center">
        <icon type="navbar-more" style="font-size: 24px;" />
      </div>
    </a-popover>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { getDocsUrl } from '@/utils/utils'

export default {
  name: 'MorePopover',
  data () {
    return {
      visible: false,
    }
  },
  computed: {
    ...mapGetters(['scope', 'isAdminMode', 'isDomainMode']),
    ...mapState('app', {
      customer: state => state.customer,
      companyInfo: state => state.companyInfo,
    }),
  },
  created () {
    this.$store.dispatch('app/fetchUserGuide')
  },
  methods: {
    async menuClick (item) {
      this.visible = false
      const key = item.key
      if (key === 'docs') {
        const host = window.location.hostname
        let docsOrigin = window.location.origin
        if (host === 'cloud.yunion.cn') {
          docsOrigin = 'https://docs.yunion.cn'
        } else if (host === 'staging.yunion.io') {
          docsOrigin = 'https://docs.yunion.io'
        }
        window.open(getDocsUrl(this.scope, false, docsOrigin), '_blank')
      } else if (key === 'issues') {
        window.open('https://github.com/yunionio/cloudpods/issues', '_blank')
      } else if (key === 'features') {
        this.$router.push('/guide')
      } else if (key === 'about') {
        this.$router.push('/licenses')
      } else if (key === 'cloudaccount_guide') {
        this.$store.dispatch('dialog/create', {
          name: 'CloudAccountSetupGuideDialog',
          id: 'CloudAccountSetupGuideDialog-saas',
          params: {},
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/styles/less/theme';

.trigger {
  height: 100%;
  padding: 0 20px;
  cursor: pointer;
  text-decoration: none;
}

.navbar-more-popover {
  min-width: 320px;
}

.more-popover-card {
  text-align: center;
  border: 0;
}

.more-popover-menu-item {
}

.more-popover-menu {
  padding-top: 24px;
  border: 0px;
}
</style>
